import { getProductFromSessionStorage } from "src/utils/storage/auth";

// 사용자 수 입력 범위.
// 입력 UI(LicenseCount)와 검증 스키마(useValidationSchemas)가 같은 값을 참조하도록
// 한 곳에서 관리한다. 서버 검증을 대체하지 않는 클라이언트 측 1차 방어선.
export const MAX_LICENSE_COUNT = 9999;

// WRAPSODY_ECO(OCI)만 1명부터 구매 가능, 그 외 제품은 최소 10명
export const getMinLicenseCount = (isOciProduct: boolean): number =>
  isOciProduct && getProductFromSessionStorage() === "WRAPSODY_ECO" ? 1 : 10;
